/**
 * Created by mauget on 2/24/16.
 */

import Immutable from 'immutable';

//=====================================================================================================
// This list developed from XML received in a server-sent form XML of default form theme values.
// We could alternatively prime this object from a server REST call if it existed.
//
// Lou Mauget Febrary 24, 2016
//=====================================================================================================
export default Immutable.Map( {
    '~buttonBgColor': '#EEEEEE',
    '~buttonBgDownColor': '#EEEEEE',
    '~buttonBgGradientColor': '#EEEEEE',
    '~buttonBgGradientDownColor': '#EEEEEE',
    '~buttonBgGradientOverColor': '#EEEEEE',
    '~buttonBgOverColor': '#EEEEEE',
    '~buttonBorderColor': '#000000',
    '~buttonFont': 'verdana,10, normal, normal',
    '~buttonRadius': '0',
    '~buttonStyle': 'push',
    '~buttonTextColor': '#000000',
    '~buttonTextDownColor': '#000000',
    '~buttonTextOverColor': '#000000',
    '~groupBgColor': '#FFFFFF',
    '~groupBgGradientColor': '#FFFFFF',
    '~groupBgImage': 'null',
    '~groupBgTransparent': 'false',
    '~groupBorder': '1, none, 0',
    '~groupBorderColor': '#000000',
    '~groupFont': 'verdana,10, normal, normal',
    '~groupTextColor': '#000000',
    '~groupTitleBg': '#CCCCCC',
    '~inputBgColor': '#FFFFFF',
    '~inputBorder': '1, solid, 0',
    '~inputBorderColor': '#000000',
    '~inputFont': 'verdana, 10, normal, normal',
    '~inputTextColor': '#333333',
    '~largeHeadingFont': 'verdana,20,bold, normal',
    '~largeHeadingTextColor': '#000033',
    '~linkFont': 'verdana, 10, normal, normal',
    '~linkTextColor': '#3333FF',
    '~mediumHeadingFont': 'verdana, 18, bold, normal',
    '~mediumHeadingTextColor': '#000033',
    '~pageBgColor': '#FFFFFF',
    '~pageBgImage': 'null',
    '~selectionBgColor': '#FFFFFF',
    '~selectionBgGradientColor': '#FFFFFF',
    '~selectionBorderColor': '#000000',
    '~selectionFont': 'verdana,10, normal, normal',
    '~selectionTextColor': '#333333',
    '~selectionTextOverColor': '#111111',
    '~seperatorColor': '#000033',
    '~seperatorSize': '4',
    '~smallHeadingFont': 'Verdana, 14, normal, italic',
    '~smallHeadingTextColor': '#000033',
    '~smallTextColor': '#333333',
    '~smallTextFont': 'verdana, 8, normal, normal',
    '~tableBgColor': '#FFFFFF',
    '~tableBorder': '1, solid, 0',
    '~tableBorderColor': '#000000',
    '~tableHeaderBgColor': '#FFFFFF',
    '~tableHeaderBgGradientColor': '#FFFFFF',
    '~tableHeaderFont': 'verdana, 10, normal, normal',
    '~tableHeaderTextColor': '#333333',
    '~tableRowColor1': '#EEEEEE',
    '~tableRowColor2': '#CCCCCC',
    '~textColor': '#000000',
    '~textFont': 'verdana, 10, normal, normal',
    '~margin': '0',
    '~checkBgTransparent': 'true',
    // sections
    '~sectionBgColor': '#FFFFFF',
    '~sectionTextColor': '#000000',
    '~sectionFont': 'verdana, 16, normal, normal',
    '~sectionBorder': '1, solid, 0',
    '~sectionBorderSize': '1',
    '~sectionBorderStyle': 'solid',
    '~sectionBorderColor': '#C0C0C0',
    '~sectionCornerRadius': '4',
    '~sectionCaptionBgColor': '#FFFFFF',
    '~sectionHeaderBgColor': '#F0F0F0',
    '~sectionHeaderAlignment': 'left',
    '~sectionBgTransparent': 'false',
    '~sectionBgImage': ''

});
